import { loadApiConfig, loadAdyenConfig as loadAdyenConfigUtil, loadPostHogBOConfig as loadPostHogBOConfigUtil, loadPostHogFOConfig as loadPostHogFOConfigUtil, } from "../../shared/utils/configLoader";
/**
 * Configuration service that provides type-safe access to environment variables
 * This service bridges between infrastructure (env vars) and domain (config entities)
 */
export class ConfigService {
    constructor() {
        Object.defineProperty(this, "_config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_initialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        this._config = {
            keycloak: undefined,
            api: undefined,
            adyen: undefined,
            posthogBO: undefined,
            posthogFO: undefined,
            environment: undefined,
        };
    }
    static getInstance() {
        if (!ConfigService.instance) {
            ConfigService.instance = new ConfigService();
        }
        return ConfigService.instance;
    }
    async initialize() {
        if (this._initialized)
            return;
        const [api, adyen, posthogBO, posthogFO, environment] = await Promise.all([
            this.loadApiConfig(),
            this.loadAdyenConfig(),
            this.loadPostHogBOConfig(),
            this.loadPostHogFOConfig(),
            this.loadEnvironmentConfig(),
        ]);
        this._config = {
            keycloak: undefined, // keycloak need be used before the app is initialized, so we don't load it here
            api,
            adyen,
            posthogBO,
            posthogFO,
            environment,
        };
        this._initialized = true;
    }
    loadApiConfig() {
        return loadApiConfig();
    }
    loadAdyenConfig() {
        return loadAdyenConfigUtil();
    }
    loadPostHogBOConfig() {
        return loadPostHogBOConfigUtil();
    }
    loadPostHogFOConfig() {
        return loadPostHogFOConfigUtil();
    }
    loadEnvironmentConfig() {
        return {
            isDevelopment: !import.meta.env.PROD,
            isProduction: import.meta.env.PROD,
        };
    }
    get config() {
        if (!this._initialized) {
            throw new Error("ConfigService must be initialized before use. Call initialize() first.");
        }
        return this._config;
    }
    get keycloak() {
        if (!this._initialized) {
            throw new Error("ConfigService must be initialized before use. Call initialize() first.");
        }
        return this._config.keycloak;
    }
    get api() {
        if (!this._initialized) {
            throw new Error("ConfigService must be initialized before use. Call initialize() first.");
        }
        return this._config.api;
    }
    get adyen() {
        if (!this._initialized) {
            throw new Error("ConfigService must be initialized before use. Call initialize() first.");
        }
        return this._config.adyen;
    }
    get posthogBO() {
        if (!this._initialized) {
            throw new Error("ConfigService must be initialized before use. Call initialize() first.");
        }
        return this._config.posthogBO;
    }
    get posthogFO() {
        if (!this._initialized) {
            throw new Error("ConfigService must be initialized before use. Call initialize() first.");
        }
        return this._config.posthogFO;
    }
    get environment() {
        if (!this._initialized) {
            throw new Error("ConfigService must be initialized before use. Call initialize() first.");
        }
        return this._config.environment;
    }
}
// Export a singleton instance
export const configService = ConfigService.getInstance();
